// defaults to localStorage for web
import storage from 'redux-persist/lib/storage' 

const getStorage = () => storage

export { getStorage }